import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterName from '../VeltCommentsSidebarFilterName/VeltCommentsSidebarFilterName';
import VeltCommentsSidebarFilterItem from '../VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
import VeltCommentsSidebarFilterSearch from '../VeltCommentsSidebarFilterSearch/VeltCommentsSidebarFilterSearch';
var VeltCommentsSidebarFilterVersions = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-versions-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterVersions.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterVersions.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterVersions.Search = VeltCommentsSidebarFilterSearch;
export default VeltCommentsSidebarFilterVersions;
